export const buildI18nResources = (raw: { [lang: string]: any }) => {
    const resources: Record<string, { translation: any }> = {};

    Object.keys(raw).forEach(lang => {
        resources[lang] = {
            translation: raw[lang],
        };
    });

    return resources;
};
